// extracted by mini-css-extract-plugin
export default {"header":"ProjectsUsage_header__Y8iRP","title":"ProjectsUsage_title__8OCec","value":"ProjectsUsage_value__6ZJpZ","root":"ProjectsUsage_root__LUywe"};